import { useEffect } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'

export const Transaction = () => {
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (location.pathname === '/app/transaction') {
      navigate('/app/transaction/orders?type=sell&page=1')
    }
  }, [location])

  return (
    <div className='font-dashboard pt-4 pb-12 md:px-4 min-h-screen'>
      <div className='container-lg relative'>
        <div className='flex items-center gap-3'>
          <NavLink to='/app/transaction/orders?page=1'>
            {({ isActive }) => (
              <h3
                className={`text-sm px-4 py-2 rounded-t-lg ${
                  isActive
                    ? 'bg-primary text-black'
                    : 'bg-gray-100 text-white/70'
                }`}
              >
                Orders
              </h3>
            )}
          </NavLink>
          <NavLink to='/app/transaction/trades?page=1'>
            {({ isActive }) => (
              <h3
                className={`text-sm px-4 py-2 rounded-t-lg ${
                  isActive
                    ? 'bg-primary text-black'
                    : 'bg-gray-100 text-white/70'
                }`}
              >
                Trades
              </h3>
            )}
          </NavLink>
          <NavLink to='/app/transaction/withdraws?page=1'>
            {({ isActive }) => (
              <h3
                className={`text-sm px-4 py-2 rounded-t-lg ${
                  isActive
                    ? 'bg-primary text-black'
                    : 'bg-gray-100 text-white/70'
                }`}
              >
                Withdraws
              </h3>
            )}
          </NavLink>
        </div>

        <div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
